import KEWLWebZip from '../webzip';
import updateLocation2 from '../location2';
import Base64 from './base64';
import ISONLINE from '../domainJudge.js';
import KEWLApp from './kewl.js';
import HTTPUrl from '../httpurl.js';
import KEWLSensor from '../kewlSensors.js';
import KEWLHttp from '../kewlHttp.js';
import KEWLError from '../errorReport.js';
import kewlpageevent from '../kewlpageevent.js';
// import AUTOAPIDomainCheck from '../autoAPIDomainCheck.js';
// 立即执行
import {} from '../performace.js';

window.KEWLApp.isKEWLApp && window.KEWLWebZip.findSelfZip();
